<template>
  <div class="container justify-content-center">
      <div v-if="loginError" id="error-dialog" class="alert alert-danger">
        <strong>Error</strong> {{ loginError }}
      </div>
    </div>
    <div class="login-container">
      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <div class="input-container">
            <input
              type="text"
              id="username"
              v-model="credentials.username"
              required
              @focus="isUsernameActive = true"
              @input="handleInput('username')"
              @blur="handleBlur('username')"
            />
            <label
              v-if="!usernameHasText"
              id="username-label"
              :class="{ 'input-label': true, 'active': isUsernameActive }"
              for="username"
              class="input-label"
              >E-Mail</label
            >
          </div>
        </div>
        <div class="form-group">
          <div class="input-container">
            <input
              type="password"
              id="password"
              v-model="credentials.password"
              required
              @focus="isPasswordActive = true"
              @input="handleInput('password')"
              @blur="handleBlur('password')"
            />
            <label
              v-if="!passwordHasText"
              id="password-label"
              :class="{ 'input-label': true, 'active': isPasswordActive }"
              for="password"
              class="input-label"
              >Password</label
            >
          </div>
        </div>
        <button type="submit" class="submit-button">Login</button>
        <div class="container">
          <div class="box">
            <router-link class="nav-link" to="/candidate-assessment"
              >Candidate?</router-link
            >
          </div>
          <div class="box"><span v-on:click="handleForgotPasswordClick" style="cursor:pointer;">Forgot password?</span></div>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import router from '@/router';
  import { setCookie } from '@/utils/cookies/cookieUtils.js'
  import { endpoint } from '@/utils/endpoint/endpointUtils.js'

  
  export default {
    components: {

    },
      data() {
          return {
              username: '',
              password: '',
              isUsernameActive: false,
              isPasswordActive: false,
              inputText: '',
              usernameHasText: false,
              passwordHasText: false,
          };
      },
      methods: {
          handleInput(field) {
              if (field === 'username') {
                  this.isUsernameActive = true;
                  if (field.length > 0) {
                      this.usernameHasText = true;
                  } else {
                      this.usernameHasText = false;
                  }
              } else if (field === 'password') {
                  this.isPasswordActive = true;
                  if (field.length > 0) {
                      this.passwordHasText = true;
                  } else {
                      this.passwordHasText = false;
                  }
              }
          },
          handleBlur(field) {
              if (field === 'username') {
                  if (!this.username) {
                      this.isUsernameActive = false;
                  }
  
                  if (this.credentials.username.length > 0) {
                      this.usernameHasText = true;
                  } else {
                      this.usernameHasText = false;
                  }
              } else if (field === 'password') {
                  if (!this.password) {
                      this.isPasswordActive = false;
                  }
  
                  if (this.credentials.password.length > 0) {
                      this.passwordHasText = true;
                  } else {
                      this.passwordHasText = false;
                  }
              }
          },
          handleForgotPasswordClick() {
            this.$emit('forgot-password-click', true);
          }
      },
      setup() {
          const credentials = ref({
              username: '',
              password: '',
          });
          const loginError = ref('');
  
          const login = async () => {
              try {
                  const response = await fetch(endpoint + '/api/Authentication/Login', {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(credentials.value),
                  });
  
                  if (!response.ok) {
                    loginError.value = "Check your username and/or password, and try again.";
                  }

                  const data = await response.json();
                  const token = data.token;
                  const userid = data.userID;
  
                  // Set the token as a cookie
                  setCookie('token', token, 1);
                  setCookie('userid', userid, 1);
                  
                  // Go to dashboard
                  router.push('/dashboard');
              } catch (error) {
                  // Handle errors here, such as showing a notification to the user
                  console.error('Login error:', error.message);
                  loginError.value = error.message;
              }
          };
  
          return {
              credentials,
              loginError,
              login
          };
      },
  };
  </script>
  
  <style>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  
  .login-form {
    width: 400px;
    padding: 30px;
    border: 1px solid;
    border-radius: 5px;
    border-color: #4f4f4f;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    display: block;
    margin-bottom: 5px;
  }
  
  input[type="text"],
  input[type="password"] {
    width: 300px;
    padding: 8px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    border-color: rgb(62, 68, 70);
    background-color: #4f4f4f;
    color: cornsilk;
  }
  
  .submit-button {
    width: 300px;
    padding: 10px;
    background-color: #382d61;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }
  
  .submit-button:hover {
    background-color: #72018f;
  }
  .forgot-pass {
    margin: 10px;
    text-justify: right;
    text-align: right;
    width: auto;
    display: flex;
  }
  .register {
    text-justify: left;
    text-align: left;
    width: auto;
    display: flex;
  }
  
  .box {
    width: 100%;
  }
  
  .container {
    display: grid; /* Use CSS grid */
    grid-template-columns: auto auto; /* Set columns to auto size */
    grid-gap: 10px; /* Add gap between the boxes */
    margin-top: 20px;
  }
  
  .input-container {
    position: relative;
    margin-bottom: 20px; /* Add spacing between input fields */
  }
  
  .input-field {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .input-label {
    position: absolute;
    top: 50%;
    left: 60px;
    transform: translateY(-50%);
    color: #999;
    transition: all 0.3s ease; /* Add smooth transition effect */
  }
  
  .input-field:focus + .input-label,
  .input-field:not(:placeholder-shown) + .input-label {
    top: 5px;
    font-size: 12px;
    color: #333;
  }
  
  .input-label.active {
    top: 5px;
    font-size: 12px;
    color: #333;
    display: none;
  }
  </style>
  